'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useCustomRouter } from '@/hooks/useCustomRouter';
const EventComponent = () => {
  const $ = _c(4);
  const searchParams = useSearchParams();
  const router = useCustomRouter();
  let t0;
  let t1;
  if ($[0] !== router || $[1] !== searchParams) {
    t0 = () => {
      if (!searchParams) {
        return;
      }
      const pinkey = searchParams.get("pinkey");
      if (pinkey && typeof window !== "undefined") {
        sessionStorage.setItem("pinkey", pinkey);
        const url = new URL(window.location.href);
        url.searchParams.delete("pinkey");
        router.replace(url.pathname + url.search, {
          scroll: false
        });
      }
    };
    t1 = [searchParams, router];
    $[0] = router;
    $[1] = searchParams;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
};
export const Event = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorBoundary fallback={null}><Suspense><EventComponent /></Suspense></ErrorBoundary>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};